import Link from 'gatsby-link'
import * as React from 'react'
import Button from '../button/button'
import SingInUrlProvider from '../signin/SignInUrlProvider'
import './navigation.scss'

interface INavProps {
  extraClasses?: string
  showButton?: boolean
}

class Navigation extends React.Component<INavProps, {}> {
  public handleClickSlack = () => {
    analytics.track('Slack Account OAuth Initiated', {
      category: 'Visitor',
      label: 'Sign In With Slack [navigation]',
    })
  }

  public render() {
    const extraClasses = this.props.extraClasses || ''
    return (
      <nav id="navigation" className={`navigation ${extraClasses}`}>
        <div className="navigation__content">
          <ul className="navigation__list">
            {/* <li className="navigation__item">
              <Link
                className="navigation__anchor"
                to="/how-it-works"
                activeClassName="active"
              >
                How it Works
              </Link>
            </li>
            <li className="navigation__item">
              <Link
                className="navigation__anchor"
                to="/pricing"
                activeClassName="active"
              >
                Pricing
              </Link>
            </li> */}
            <li className="navigation__item">
              <Link
                className="navigation__anchor"
                to="/about-us"
                activeClassName="active">
                About Us
              </Link>
            </li>
            <li className="navigation__item">
              <Link
                className="navigation__anchor"
                to="/support"
                activeClassName="active">
                Support
              </Link>
            </li>
          </ul>
          {/* {this.props.showButton ? (
            <SingInUrlProvider>
              <Button
                extraClasses="btn--slack btn--big"
                content=""
                onClick={this.handleClickSlack}
              />
            </SingInUrlProvider>
          ) : null} */}
        </div>
      </nav>
    )
  }
}

export default Navigation



// WEBPACK FOOTER //
// ./src/components/navigation/navigation.tsx